import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import smallHouseOverview from '../img/elevation_img_11.avif'; // Replace with your actual image
import smallHouseGroundFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import smallHouseFirstFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import compactLiving from '../img/elevation_img_11.avif'; // Replace with your actual image
import simpleExterior from '../img/elevation_img_11.avif'; // Replace with your actual image
import './ProjectStyles.css';

const HousePlan20x30 = () => {
  useScrollToTop();
  return (
    <div className='project-container'> {/* Using the general project container style */}
      <h2>Compact and Efficient 20x30 House Plan: Ideal for Modern Living</h2>
      <img className='project-image' src={smallHouseOverview} alt="20x30 House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Discover a smart and space-saving two-story house plan designed for a 20x30 sqft plot. This plan focuses on efficient use of every square foot, providing comfortable living spaces ideal for small families or individuals in urban settings like Patna, Bihar.</p>

        <h3>Design Philosophy: Maximizing Small Spaces</h3>
        <p>The core of this design is to create a functional and comfortable home within a limited footprint. Vertical expansion allows for distinct living zones while careful layout and smart storage solutions ensure a spacious feel despite the compact size. Natural light and ventilation are still prioritized to create a pleasant living environment.</p>

        <h3>Inspiration for Compact Living</h3>
        <div className='inspiration-gallery'>
          {/* Replace these with actual image paths that resonate with efficient small home designs */}
          <img src='../img/efficient_kitchen_inspiration.jpg' alt='Compact Living Inspiration 1' className='project-image' />
          <img src='../img/multi_functional_space_inspiration.jpg' alt='Compact Living Inspiration 2' className='project-image' />
          <img src='../img/vertical_living_inspiration.jpg' alt='Compact Living Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Smart Use of Space</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 600 sqft)</h4>
          <img className='project-image' src={smallHouseGroundFloor} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically features a compact living room, a functional kitchen (potentially open-plan to save space), a common bathroom, and a staircase leading to the first floor. The design aims for an open and airy feel despite the limited area.</p>
          <ul>
            <li><strong>Cozy Living Room Area</strong></li>
            <li><strong>Efficient Kitchen Layout</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Staircase to the First Floor</strong></li>
            <li>Potential for a small entry foyer</li>
          </ul>
          {/* You could add more specific details about room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 600 sqft)</h4>
          <img className='project-image' src={smallHouseFirstFloor} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually accommodates bedrooms, depending on the family's needs. A master bedroom and one additional bedroom or a multi-purpose room are common configurations. A bathroom may also be located on this floor for convenience.</p>
          <ul>
            <li><strong>Master Bedroom</strong></li>
            <li><strong>Additional Bedroom/Multi-Purpose Room</strong></li>
            <li>Bathroom (can be attached or common)</li>
            <li>Small landing area</li>
          </ul>
          {/* You could add more specific details about room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> ~600 sqft</li>
            <li><strong>First Floor:</strong> ~600 sqft</li>
            <li><strong>Total Built Area:</strong> ~1200 sqft</li>
            <p>*Note: These are approximate figures and can vary based on the specific architectural design.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Comfortable Interiors: Functionality and Style</h3>
        <div className='interior-feature'>
          <h4>Bright and Airy Spaces</h4>
          <img className='project-image' src={compactLiving} alt="Compact Living Area" loading="lazy" />
          <p>Strategic use of windows and light colors can make even small spaces feel more open and inviting. Maximizing natural light is key to comfortable living.</p>
        </div>

        <div className='interior-feature'>
          <h4>Smart Storage Solutions</h4>
          <p>Integrated storage, wall-mounted units, and multi-functional furniture are essential to maximize space and maintain a clutter-free environment in a compact home.</p>
        </div>

        <div className='interior-feature'>
          <h4>Efficient Layout</h4>
          <p>The floor plan is designed to minimize wasted space, ensuring a smooth flow between different areas of the house.</p>
        </div>

        {/* Add more interior features relevant to small home living */}
      </div>

      <div className='project-details'>
        <h3>Practical Exterior: Simplicity and Durability</h3>
        <img className='project-image' src={simpleExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>Clean and Functional Design</h4>
          <p>The exterior design often emphasizes simplicity and clean lines, making efficient use of the available plot area.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Durable and Low-Maintenance Materials</h4>
          <p>Choosing durable and low-maintenance materials is important for a compact home in an urban setting.</p>
        </div>

        {/* Add more exterior features */}
      </div>

      <div className='project-details'>
        <h3>Quality Considerations for Your Compact Home</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Reinforced Concrete</li>
            <li><strong>Exterior Walls:</strong> Brick masonry with plastering and suitable paint</li>
            <li><strong>Roofing:</strong> RCC slab with waterproofing</li>
            <li><strong>Windows and Doors:</strong> Functional and durable options like UPVC or powder-coated aluminum</li>
            <li><strong>Flooring:</strong> Easy-to-clean and durable options such as tiles</li>
          </ul>
        </div>

        {/* Optional: Vaastu considerations */}
        {/* <h4>Vaastu Shastra Considerations (Optional)</h4>
        <p>Even in a compact design, Vaastu principles can be incorporated to optimize the flow of energy. Careful consideration of entrances, room placements, and orientations can be included in a customized plan.</p> */}
      </div>

      {/* Optional: Location and Context */}
      {/* <div className='project-details'>
        <h3>Suitable for Urban Plots in Patna</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This house plan is well-suited for the typical 20x30 plots found in many urban areas of Patna, offering a comfortable living solution within a smaller footprint.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Designed for narrow plots common in urban settings.</li>
            <li>Focus on maximizing vertical space.</li>
            <li>Consideration for local building regulations.</li>
          </ul>
        </div>
      </div> */}

      <div className='project-details'>
        <h3>Ready to Build Your Smart and Compact Home?</h3>
        <p>This 20x30 two-story house plan offers a practical and efficient design for modern living in Patna. Connect with experienced architects and builders to tailor this plan to your specific needs and local building codes.</p>
        {/* Add your contact information or links to architectural services here */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Custom Design</Button>
                </a>
      </div>
    </div>
  );
};

export default HousePlan20x30;